export const CREATE_CARE_PROVIDER_REQUEST = 'CREATE_CARE_PROVIDER_REQUEST';

export const createCareProviderRequest = ( careProviderData ) => ({
    type: CREATE_CARE_PROVIDER_REQUEST,
    payload: { ...careProviderData },
});
